<template>
  <nav class="user-info__menu">
    <ui-logo :target="'domain'" :is-logo-white="false"/>
    <ul class="menu-list">
      <li class="list" v-for="item in MenuList" :key="item">
        <router-link class="item" :class="{on: item === routeName}" :to="{name: `${item}`}">{{ $t(`userInfo.lnb.${item}`) }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import UiLogo from '@/components/ui/UiLogo.vue'

export default {
  components: {
    UiLogo
  },
  props: [
    'routeName'
  ],
  computed: {
    ...mapState([
      'userData'
    ]),
    MenuList () {
      if (this.userData.isGmc) {
        return [
          'managePlan',
          'requestManagement',
          'userManagement',
          'pageManagement',
          'myInformation',
          'jam',
          'ipBlocking'
        ]
      } else {
        return [
          'myInformation',
          'ipBlocking'
        ]
      }
    }
  },
  methods: {
    showCouponLayer () {
      this.$emit('showCouponLayer')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info__menu {
  .menu-list {
    position: absolute;
    top: 134px;
    width: 210px;

    .list:first-child .item {
      border-top: 1px solid #ebebeb;
    }

    .item {
      display: block;
      padding: 18px 12px;
      font-size: 13px;
      font-weight: bold;
      color: #2f2f2f;

      &.on {
        color: $brandColor;
      }
    }
    &.ab {

    }
  }
  .btn__coupon {
    width: 186px;
    height: 38px;
    border-radius: 20px;
    border: solid 1px #bbbbbb;
    background-color: #ffffff;
    position: absolute;
    left: 12px;
    bottom: 12px;
    text-align: right;

    /deep/ .icon {
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
    }
  }
}
</style>
